import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@ibk/shared-ui';
import styles from './ContentMessage.module.css';
export function ContentMessage({ icon, title, subtitle, dataTestId }) {
    return (_jsxs("div", { className: styles.main, "data-testid": `${dataTestId}-alert`, children: [_jsx(Icon, { "data-testid": `${dataTestId}-alert-icon`, name: icon, alt: '' }), _jsxs("div", { className: styles.textContainer, children: [_jsx("div", { "data-testid": `${dataTestId}-alert-title`, className: styles.title, children: title }), _jsx("div", { "data-testid": `${dataTestId}-alert-subtitle`, className: styles.subtitle, children: subtitle })] })] }));
}
